
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as cartKR0HH9_Nkaf5tBd1IzcSF0hrwdyOXjYUVa7u0F37rjwMeta } from "/codebuild/output/src1943383543/src/hyp-loyalty-frontend/pages/cart.vue?macro=true";
import { default as homexEDZcDtVMgYzkzOy_456af_eTl_h800xvMmrYv1EU8aIMMeta } from "/codebuild/output/src1943383543/src/hyp-loyalty-frontend/pages/home.vue?macro=true";
import { default as indexcRXuAIXDTuRroC193GXnUSCeFa2qb2v6AfJYZSP1kFsMeta } from "/codebuild/output/src1943383543/src/hyp-loyalty-frontend/pages/index.vue?macro=true";
import { default as paymentlIoT1O12V8HfC7XbXiJYuEhtqDK3Ra5DN3HlVuLaeWsMeta } from "/codebuild/output/src1943383543/src/hyp-loyalty-frontend/pages/payment.vue?macro=true";
import { default as profilekbpSHjeeExlUxyJJbdrGWvbpQEN0ja2K0ENDHP2043sMeta } from "/codebuild/output/src1943383543/src/hyp-loyalty-frontend/pages/profile.vue?macro=true";
import { default as checkoutpE4vmTCCFTjw_Er6tEU_459FUr62NkEJKyypj2SCplO0wMeta } from "/codebuild/output/src1943383543/src/hyp-loyalty-frontend/pages/checkout.vue?macro=true";
import { default as thankyouyzpIyLODePuSq5kT0r6k0VKxaYN8j39yc_3Vq3XDRVkMeta } from "/codebuild/output/src1943383543/src/hyp-loyalty-frontend/pages/thankyou.vue?macro=true";
import { default as wishlistcKNJpRS_0HO_7UawZQEilr5NV5tGMEsWvtWTSF5KB8wMeta } from "/codebuild/output/src1943383543/src/hyp-loyalty-frontend/pages/wishlist.vue?macro=true";
import { default as notificationsoLvVcgjCTNkqJEEyYzFxMFNizx8G5hxo_adC75yWTG0Meta } from "/codebuild/output/src1943383543/src/hyp-loyalty-frontend/pages/notifications.vue?macro=true";
import { default as indexQRr6KNYP_45hfgPQtvVwbQO4Mv4pA_45oOqh_ovuYsW0YmgMeta } from "/codebuild/output/src1943383543/src/hyp-loyalty-frontend/pages/rewards/index.vue?macro=true";
import { default as _91slug_934uybx6YE0kwLbr7pwt2ZsXkQKydlDDxBL6ibFzZo0x8Meta } from "/codebuild/output/src1943383543/src/hyp-loyalty-frontend/pages/static/[slug].vue?macro=true";
import { default as points_45historyuj0IdSHFLW9AZxeexlso8s6ZykKRKVVhlunnvhIQhF0Meta } from "/codebuild/output/src1943383543/src/hyp-loyalty-frontend/pages/points-history.vue?macro=true";
import { default as refer_45and_45earnOt3qh1DmMRvOP0L2Z4xqu8NtW55bxmNXD_45BKUjJjcdUMeta } from "/codebuild/output/src1943383543/src/hyp-loyalty-frontend/pages/refer-and-earn.vue?macro=true";
import { default as _91id_93PYuXLLdrtclEcbHwPNy1kMZYuJf_Ql_45ZTJG10F_45YC2EMeta } from "/codebuild/output/src1943383543/src/hyp-loyalty-frontend/pages/order-history/[id].vue?macro=true";
import { default as index3YG8FWFTeJ9p_454kgvVQN7Q5ZfGt3XvRaCWD5ByIAKKIMeta } from "/codebuild/output/src1943383543/src/hyp-loyalty-frontend/pages/order-history/index.vue?macro=true";
import { default as indexRn_45RssgxAglTpD_45uBeVNeZbcwiYwXg7Me7LDAle4aGAMeta } from "/codebuild/output/src1943383543/src/hyp-loyalty-frontend/pages/retailpartners/index.vue?macro=true";
import { default as _91id_93EiEDwwIs1cdTgzf68crgkAmTborpiwHTwCIbsqCdzdMMeta } from "/codebuild/output/src1943383543/src/hyp-loyalty-frontend/pages/rewards/details/[id].vue?macro=true";
import { default as indexOP02Vc0tWFW_Z1fb6nPWhu5dOBfkuxOPj1VOzPIgCjQMeta } from "/codebuild/output/src1943383543/src/hyp-loyalty-frontend/pages/payment-history/index.vue?macro=true";
import { default as payment_45detailsLxnoyiOkWhLz_45d3QcAJ8aEWSqriS_pf1b_QQSzC7_45yYMeta } from "/codebuild/output/src1943383543/src/hyp-loyalty-frontend/pages/payment-history/payment-details.vue?macro=true";
export default [
  {
    name: "cart",
    path: "/cart",
    meta: cartKR0HH9_Nkaf5tBd1IzcSF0hrwdyOXjYUVa7u0F37rjwMeta || {},
    component: () => import("/codebuild/output/src1943383543/src/hyp-loyalty-frontend/pages/cart.vue")
  },
  {
    name: "home",
    path: "/home",
    meta: homexEDZcDtVMgYzkzOy_456af_eTl_h800xvMmrYv1EU8aIMMeta || {},
    component: () => import("/codebuild/output/src1943383543/src/hyp-loyalty-frontend/pages/home.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexcRXuAIXDTuRroC193GXnUSCeFa2qb2v6AfJYZSP1kFsMeta || {},
    component: () => import("/codebuild/output/src1943383543/src/hyp-loyalty-frontend/pages/index.vue")
  },
  {
    name: "payment",
    path: "/payment",
    meta: paymentlIoT1O12V8HfC7XbXiJYuEhtqDK3Ra5DN3HlVuLaeWsMeta || {},
    component: () => import("/codebuild/output/src1943383543/src/hyp-loyalty-frontend/pages/payment.vue")
  },
  {
    name: "profile",
    path: "/profile",
    meta: profilekbpSHjeeExlUxyJJbdrGWvbpQEN0ja2K0ENDHP2043sMeta || {},
    component: () => import("/codebuild/output/src1943383543/src/hyp-loyalty-frontend/pages/profile.vue")
  },
  {
    name: "checkout",
    path: "/checkout",
    meta: checkoutpE4vmTCCFTjw_Er6tEU_459FUr62NkEJKyypj2SCplO0wMeta || {},
    component: () => import("/codebuild/output/src1943383543/src/hyp-loyalty-frontend/pages/checkout.vue")
  },
  {
    name: "thankyou",
    path: "/thankyou",
    component: () => import("/codebuild/output/src1943383543/src/hyp-loyalty-frontend/pages/thankyou.vue")
  },
  {
    name: "wishlist",
    path: "/wishlist",
    component: () => import("/codebuild/output/src1943383543/src/hyp-loyalty-frontend/pages/wishlist.vue")
  },
  {
    name: "notifications",
    path: "/notifications",
    component: () => import("/codebuild/output/src1943383543/src/hyp-loyalty-frontend/pages/notifications.vue")
  },
  {
    name: "rewards",
    path: "/rewards",
    meta: indexQRr6KNYP_45hfgPQtvVwbQO4Mv4pA_45oOqh_ovuYsW0YmgMeta || {},
    component: () => import("/codebuild/output/src1943383543/src/hyp-loyalty-frontend/pages/rewards/index.vue")
  },
  {
    name: "static-slug",
    path: "/static/:slug()",
    component: () => import("/codebuild/output/src1943383543/src/hyp-loyalty-frontend/pages/static/[slug].vue")
  },
  {
    name: "points-history",
    path: "/points-history",
    component: () => import("/codebuild/output/src1943383543/src/hyp-loyalty-frontend/pages/points-history.vue")
  },
  {
    name: "refer-and-earn",
    path: "/refer-and-earn",
    meta: refer_45and_45earnOt3qh1DmMRvOP0L2Z4xqu8NtW55bxmNXD_45BKUjJjcdUMeta || {},
    component: () => import("/codebuild/output/src1943383543/src/hyp-loyalty-frontend/pages/refer-and-earn.vue")
  },
  {
    name: "order-history-id",
    path: "/order-history/:id()",
    component: () => import("/codebuild/output/src1943383543/src/hyp-loyalty-frontend/pages/order-history/[id].vue")
  },
  {
    name: "order-history",
    path: "/order-history",
    component: () => import("/codebuild/output/src1943383543/src/hyp-loyalty-frontend/pages/order-history/index.vue")
  },
  {
    name: "retailpartners",
    path: "/retailpartners",
    meta: indexRn_45RssgxAglTpD_45uBeVNeZbcwiYwXg7Me7LDAle4aGAMeta || {},
    component: () => import("/codebuild/output/src1943383543/src/hyp-loyalty-frontend/pages/retailpartners/index.vue")
  },
  {
    name: "rewards-details-id",
    path: "/rewards/details/:id()",
    meta: _91id_93EiEDwwIs1cdTgzf68crgkAmTborpiwHTwCIbsqCdzdMMeta || {},
    component: () => import("/codebuild/output/src1943383543/src/hyp-loyalty-frontend/pages/rewards/details/[id].vue")
  },
  {
    name: "payment-history",
    path: "/payment-history",
    component: () => import("/codebuild/output/src1943383543/src/hyp-loyalty-frontend/pages/payment-history/index.vue")
  },
  {
    name: "payment-history-payment-details",
    path: "/payment-history/payment-details",
    component: () => import("/codebuild/output/src1943383543/src/hyp-loyalty-frontend/pages/payment-history/payment-details.vue")
  }
]